import {css} from 'lit';
export const styles = css`:host {
  --size: 100px;
  --icon-size: calc(var(--size) * 0.35);

  display: inline-block;
  font-size: var(--font-size-sm);
  font-weight: 700;
  text-align: center;
  line-height: var(--line-height-nav);
}

a {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  width: var(--size);
}

a > figure,
  a > ef-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
    width: var(--size);
    height: var(--size);
    background-color: transparent;
    background-color: var(--bg, transparent);
    border-radius: 4px;
    transition: all var(--transition-timing) var(--transition-duration);
  }

a img {
    max-width: 60%;
    max-height: 60%;
  }

a > ef-icon {
    color: var(--icon-color);
    font-size: var(--icon-size);
  }

@media (hover: hover) {
    a:hover > ef-icon,
    a:hover > figure {
      background-color: transparent;
      background-color: var(--bg-hover, transparent);
    }
  }

a:active > ef-icon,
  a:active > figure {
    background-color: transparent;
    background-color: var(--bg-active, transparent);
  }

.rounded {
  --size: 80px;
}

.rounded > ef-icon,
.rounded > figure {
  height: calc(var(--size) - 10px);
  width: calc(var(--size) - 10px);
  border-radius: 50%;
}

.primary,
.white {
  --link-text: var(--dark-text);
  --link-text-hover: var(--dark-text);
  --link-text-active: var(--dark-text);
}

.primary {
  --bg: var(--primary);
  --bg-hover: var(--primary-600);
  --bg-active: var(--primary-700);
  --icon-color: var(--contrast-light);
}

.white {
  --bg: var(--contrast-light);
  --bg-hover: var(--gray-200);
  --bg-active: var(--gray-000);
  --icon-color: var(--primary);
}
`;
export default styles;
